(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[593],{

/***/ 9311:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[id]",
      function () {
        return __webpack_require__(3388);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3992);
/* harmony import */ var _Layout_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6627);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8351);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__);







const CircleImages = (param)=>{
    let { title , subtitle , image , href , to  } = param;
    const initials = title.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "").toUpperCase().substring(0, 3);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: to,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["circle-image-container"]), "margin m0a"),
        children: [
            image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
                src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__/* .imageResizer */ .J)(image, 200, 200),
                width: "150px",
                height: "150px",
                labelHeight: "150px",
                labelWidth: "150px",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default().circles), "mb-4", "mx-auto"),
                alt: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-logo"]), "mb-4", "mx-auto"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-inicials"]),
                    children: initials
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "text-black text-center mb-2 font-secondary fw-700 fs-16px",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center color-gray-super-light font-primary fs-13px font-primary",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircleImages);


/***/ }),

/***/ 543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CustomError_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8883);
/* harmony import */ var _CustomError_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CustomError_module_css__WEBPACK_IMPORTED_MODULE_3__);




const CustomError = (param)=>{
    let { statusCode , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: statusCode ? "".concat(statusCode, ": ").concat(typeof title === "string" ? title : "Error") : "Error"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_CustomError_module_css__WEBPACK_IMPORTED_MODULE_3___default().customError),
                children: [
                    statusCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: statusCode
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: title
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomError);


/***/ }),

/***/ 7339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4051);
/* harmony import */ var _components_Layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1286);
/* harmony import */ var _components_Layout_Wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1350);
/* harmony import */ var _GalleryErrorPage_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9240);
/* harmony import */ var _GalleryErrorPage_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_GalleryErrorPage_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _HomePage_HomeCarousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7062);
/* harmony import */ var _components_CustomError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(543);








const GalleryErrorPage = (param)=>{
    let { status , gallery , featuredGalleries  } = param;
    const galleryName = (gallery === null || gallery === void 0 ? void 0 : gallery.name) ? "".concat(gallery.name) : "The gallery you are looking for";
    const getErrorMessage = (status)=>{
        switch(status){
            case 404:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "The gallery ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: galleryName
                        }),
                        " does not exist."
                    ]
                });
            case 403:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: galleryName
                        }),
                        " is not available. Check out these other galleries instead:"
                    ]
                });
            case 500:
            default:
                return "Something went wrong. Please try again later.";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Wrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: "justify-content-center text-black fs-15px fs-mobile-14px ".concat(featuredGalleries ? (_GalleryErrorPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().galleryErrorPageExtended) : (_GalleryErrorPage_module_css__WEBPACK_IMPORTED_MODULE_7___default().galleryErrorPage)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomError__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        title: getErrorMessage(status)
                    })
                }),
                featuredGalleries && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HomePage_HomeCarousel__WEBPACK_IMPORTED_MODULE_4__/* .HomeCarousel */ .V, {
                        featuredGalleries: featuredGalleries
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GalleryErrorPage);


/***/ }),

/***/ 7062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HomeCarousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1555);
/* harmony import */ var react_multi_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6529);
/* harmony import */ var _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3372);
/* harmony import */ var _services_utils_useNavigateTo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5334);
/* harmony import */ var _components_CirclesImages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3280);







const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1200
        },
        items: 6,
        slidesToSlide: 5
    },
    desktopSmall: {
        breakpoint: {
            max: 1200,
            min: 1024
        },
        items: 4,
        slidesToSlide: 4
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2,
        slidesToSlide: 2
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        slidesToSlide: 1
    }
};
const HomeCarousel = (param)=>{
    let { featuredGalleries  } = param;
    const navigateTo = (0,_services_utils_useNavigateTo__WEBPACK_IMPORTED_MODULE_4__/* .useNavigateTo */ .j)();
    const onNavigate = async ()=>{
        await navigateTo("/galleries");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-black mb-1 fs-24px",
                                        children: "Featured Galleries"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "color-gray-super-light font-primary fs-13px",
                                        children: "A selection of our favorite galleries and artists."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        className: "text-left text-sm-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            onClick: ()=>onNavigate(),
                            className: "font-primary td-u fs-14px cursor-pointer color-black",
                            children: "View all"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "position-relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_multi_carousel__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    additionalTransfrom: 0,
                    arrows: true,
                    autoPlaySpeed: 3000,
                    centerMode: false,
                    className: "w-100",
                    containerClass: "container-with-dots home-galleries-carousel",
                    dotListClass: "",
                    draggable: true,
                    focusOnSelect: false,
                    infinite: false,
                    itemClass: "",
                    keyBoardControl: true,
                    minimumTouchDrag: 80,
                    renderButtonGroupOutside: false,
                    renderDotsOutside: false,
                    responsive: responsive,
                    children: featuredGalleries.map((featuredGallery)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CirclesImages__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                title: featuredGallery.gallery.name,
                                subtitle: featuredGallery.gallery.address,
                                image: featuredGallery.gallery.thumbnail,
                                href: "/galleries/[id]",
                                to: _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_3__/* .linksBuilder.galleries */ .m.galleries(featuredGallery.gallery.domain)
                            })
                        }, "featured-galleries-".concat(featuredGallery.gallery.id)))
                })
            })
        ]
    });
};


/***/ }),

/***/ 3388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _features_pages_GalleryDetailPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1221);
/* harmony import */ var _features_pages_GalleryErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7339);




const GalleryDetail = (param)=>{
    let { errorCode , galleryDetails , featuredGalleries  } = param;
    if (errorCode && errorCode !== 200) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_pages_GalleryErrorPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        status: errorCode,
        gallery: galleryDetails,
        featuredGalleries: featuredGalleries
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_pages_GalleryDetailPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        galleryDetails: galleryDetails
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (GalleryDetail);


/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-image-container":"CircleImages_circle-image-container__3OhLu","circles":"CircleImages_circles__kYojl","gallery-logo":"CircleImages_gallery-logo__7PsMY","gallery-inicials":"CircleImages_gallery-inicials__MpC3t"};

/***/ }),

/***/ 8883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customError":"CustomError_customError__o6Ond"};

/***/ }),

/***/ 9240:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"galleryErrorPage":"GalleryErrorPage_galleryErrorPage__D9t87","galleryErrorPageExtended":"GalleryErrorPage_galleryErrorPageExtended__pxzKC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [144,686,529,501,317,221,774,888,179], function() { return __webpack_exec__(9311); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);